import { useEffect, useState } from "react";

import { Input } from "../../../components/ui/input";
import { Label } from "../../../components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../../components/ui/select";
import { Textarea } from "../../../components/ui/textarea";
import { cn, getCharCount } from "../../../lib/utils.js";
import WordCount from "../../../components/shared/WordCount.jsx";
const CONTRACTOR_TYPES = ["Civil", "Electrical", "Plumbing", "Painting", "Carpentry", "Flooring", "HVAC", "Roofing"];

const ContractorForm = ({ formData, setFormData }) => {
  const [isOther, setIsOther] = useState(false);
  const [customType, setCustomType] = useState("");
const isAddressOverLimit = getCharCount(formData.address) > 500;
  useEffect(() => {
    if (formData.type && !CONTRACTOR_TYPES.includes(formData.type)) {
      setIsOther(true);
      setCustomType(formData.type);
    } else {
      setIsOther(false);
      setCustomType("");
    }
  }, [formData.type]);

  const handleTypeChange = (value) => {
    if (value === "Other") {
      setIsOther(true);
      setFormData({ ...formData, type: customType });
    } else {
      setIsOther(false);
      setFormData({ ...formData, type: value });
    }
  };

  const handleCustomTypeChange = (e) => {
    const value = e.target.value;
    setCustomType(value);
    setFormData({ ...formData, type: value });
  };

  return (
    <div className="space-y-4">
      <div>
        <Label htmlFor="contractorName">
          Contractor Name <span className="text-red-500">*</span>
        </Label>
        <Input
          id="contractorName"
          value={formData.contractorName || ""}
          onChange={(e) => setFormData({ ...formData, contractorName: e.target.value })}
          placeholder="Enter contractor name"
          required
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <Label htmlFor="contact">Contact Information</Label>
          <Input
            id="contact"
            value={formData.contact || ""}
            onChange={(e) => setFormData({ ...formData, contact: e.target.value })}
            placeholder="Phone or email"
          />
        </div>

        <div>
          <Label htmlFor="type">
            Contractor Type <span className="text-red-500">*</span>
          </Label>
          <Select value={isOther ? "Other" : formData.type || ""} onValueChange={handleTypeChange}>
            <SelectTrigger id="type">
              <SelectValue placeholder="Select type" />
            </SelectTrigger>
            <SelectContent>
              {CONTRACTOR_TYPES.map((type) => (
                <SelectItem key={type} value={type}>
                  {type}
                </SelectItem>
              ))}
              <SelectItem value="Other">Other</SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>

      {isOther && (
        <div className="animate-in fade-in slide-in-from-top-2 duration-300">
          <Label htmlFor="customType">
            Specify Other Type <span className="text-red-500">*</span>
          </Label>
          <Input
            id="customType"
            value={customType}
            onChange={handleCustomTypeChange}
            placeholder="Enter custom contractor type"
            required
          />
        </div>
      )}

      <div>
        <Label htmlFor="referBy">Refered By</Label>
        <Input
          id="referBy"
          value={formData.referBy || ""}
          onChange={(e) => setFormData({ ...formData, referBy: e.target.value })}
          placeholder="Who refered this contractor?"
        />
      </div>

      <div>
          <Label htmlFor="address">Address</Label>
          <Textarea
            id="address"
            value={formData.address || ""}
            onChange={(e) => setFormData({ ...formData, address: e.target.value })}
            placeholder="Contractor address"
            rows={3}
            className={cn(isAddressOverLimit && "border-red-500")}
          />
          <WordCount text={formData.address} />
      </div>
    </div>
  );
};

export default ContractorForm;
